import { animationDuration } from "../../../../../../settings";

// eslint-disable-next-line import/prefer-default-export
export var slowAnimationTime = "".concat(animationDuration.slow / 1000, "s");